// extracted by mini-css-extract-plugin
export default {"loading":"styles_loading__oQrfA","error":"styles_error__0LeXg","errorText":"styles_errorText__rCWyV","separator":"styles_separator__OTQgZ"};